module.exports = __webpack_public_path__ + "static/img/Alvin Mustafa-full.6493ae7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile/full/Alvin Mustafa-full.png
// module id = rROW
// module chunks = 1